'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const FormBuilder = require('./../builder');
const Translator = require('./../../../core/translator');
const ListItem = require('./../../../services/listItem');

let ElementClass = require('./../elementClass');

FormBuilder.register('select', function(config) {
    let self = {};

    self = new ElementClass(config);
    self.multiple = config.multiple || false;

    let $select;
    let $chooseWrap = jQuery('<div class="choose-wrap mt-2"></div>');

    self.createItemList = function(item) {
        let $item = ListItem.create({
            name: item.label,
            id: item.id,
            buttons: [
                {
                    iconClass: 'icon-times',
                    onClick: function() {
                        let deleteFunc = () => {
                            $select.append(`<option value="${$item.attr('data-uid')}">${$item.find('span').text()}</option>`);

                            $item.remove();
                        };

                        if (typeof config.onDelete === 'function') {
                            config.onDelete(item, deleteFunc);
                        } else {
                            deleteFunc();
                        }
                    },
                },
            ],
        });

        return $item;
    };

    self.selectItemList = function(item) {
        $chooseWrap.append(self.createItemList(item));

        $select.find(`option[value="${item.id}"]`).remove();
    };

    self.render = function($wrap) {
        $select = jQuery('<select/>');
        let $element = jQuery('<div class="cloud-control cloud-select"/>');
        let $label;

        self.options = (typeof config.options === 'object') ? config.options : [];

        if ((/number|string/).test(typeof config.value)) {
            self.selected = [config.value];
        } else if ('object' === typeof config.value) {
            self.selected = config.value;
        } else {
            self.selected = [];
        }

        $select.attr('name', self.name);
        $select.attr('disabled', self.disabled);

        if (self.label) {
            $label = jQuery('<label/>');

            if (self.labelClass) {
                $label.addClass(self.labelClass);
            }

            $label.text(self.label);
            $wrap.append($label);
        }

        if (true === self.multiple) {
            $select.attr('multiple', true);
            $select.attr('name', $select.name + '[]');
        }
        if (self.elementClass) {
            $select.addClass(self.elementClass);
        }

        if (config.defaultOption) {
            $select.prepend(`<option value="backbee-default">${config.defaultOption}</option>`);
        }

        if (typeof config.onChange === 'function') {
            $select.on('change', function(e) {
                config.onChange(e, config.form);
            });
        }

        let count = self.options.length || Object.keys(self.options).length;

        _.forEach(self.options, function(option, key) {
            let $option = jQuery('<option/>');

            $option.val(key);
            $option.text(Translator.translate(option));

            if (-1 !== self.selected.indexOf(key) || count === 1) {
                $option.attr('selected', true);
            }

            $select.append($option);
        });

        $element.append($select);
        $wrap.append($element);


        if (config.renderType === 'list') {
            self.selected.forEach((select) => {
                if (!select.label) {
                    select.label = $select.find(`option[value="${select.id}"]`).text();
                }

                self.selectItemList(select);
            });

            $select.on('change', function() {
                let $option = jQuery(this).find('option:selected');

                self.selectItemList({id: $option.val(), label: $option.text()});
            });

            $wrap.append($chooseWrap);
        }
    };

    self.getData = function() {
        let data = [];

        if (config.renderType === 'list') {
            $chooseWrap.children().each(function() {
                let $option = jQuery(this);

                data.push($option.attr('data-uid'));
            });

            return data;
        }

        self.$.find('option').each(function() {
            let $option = jQuery(this);

            if ($option.is(':selected')) {
                if (true === self.multiple) {
                    data.push($option.val());
                } else {
                    data = $option.val();

                    if (data === 'backbee-default') {
                        data = null;
                    }

                    return false;
                }
            }
        });

        return (true !== self.multiple) ? data : ((data.length > 0) ? data : null);
    };

    return self;
});
